import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
/* Constants */
import {
  PRIVATE_PARTY_SELL_CAR_CTA,
  PRIVATE_PARTY_SELL_CAR_TED6839,
  CREATIVE_ID_ENTRY_PRIVATE_PARTY,
  PRIVATE_PARTY_SELL_CAR_TED6883,
} from 'site-modules/shared/constants/private-party/private-party';
import { PRIVATE_PARTY_EVENTS } from 'site-modules/shared/constants/private-party/private-party-events';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { venomHistory } from 'client/utils/history/venom-history';
/* Tracking */
import { EventToolbox } from 'client/utils/event-toolbox';
import { EngagementHandler } from 'client/engagement-handlers';
import { PrivatePartyEngagementHandler } from 'client/engagement-handlers/private-party-engagement-handler/private-party-engagement-handler';

import './private-party-sell-car.scss';

EngagementHandler.register(PrivatePartyEngagementHandler);

export function PrivatePartySellCar({ ted6839Recipe, ted6883Recipe, isMobile }) {
  const isTED6883Enabled = Boolean(ted6883Recipe);
  const content = isTED6883Enabled
    ? PRIVATE_PARTY_SELL_CAR_TED6883[ted6883Recipe]
    : PRIVATE_PARTY_SELL_CAR_TED6839[ted6839Recipe];
  const { imageSrc, imageSrcMobile, benefits } = content;
  const isTED6839Chal1Chal2Chal3 = ['chal-1', 'chal-2', 'chal-3'].includes(ted6839Recipe);
  const isTED6839Chal4Chal5Chal6 = ['chal-4', 'chal-5', 'chal-6'].includes(ted6839Recipe);
  const isTED6883Chal1Chal2Chal3 = ['chal-1', 'chal-2', 'chal-3'].includes(ted6883Recipe);
  const isTED6883Chal4Chal5Chal6 = ['chal-4', 'chal-5', 'chal-6'].includes(ted6883Recipe);
  const isTED6839Chal4 = ted6839Recipe === 'chal-4';
  const isTED6883Chal1 = ted6883Recipe === 'chal-1';

  const image = isMobile && (isTED6839Chal4Chal5Chal6 || isTED6883Chal1Chal2Chal3) ? imageSrcMobile : imageSrc;
  const url = '/sell-car/private/create-listing/';
  const caramelLink = 'https://www.drivecaramel.com/how-it-works';
  const caramelBtnText = isTED6839Chal1Chal2Chal3 ? 'How Caramel works' : 'How it works';

  const handleClick = useCallback(() => {
    EventToolbox.fireCustomEvent(PRIVATE_PARTY_EVENTS.START_PP_LISTING, { value: PRIVATE_PARTY_SELL_CAR_CTA });
    venomHistory.push(url);
  }, []);
  const handleCaramelBtnClick = useCallback(() => {
    EventToolbox.fireCustomEvent(PRIVATE_PARTY_EVENTS.CARAMEL_WEBSITE_CLICKOUT, { value: caramelBtnText });

    /* That's a temporary solution to prevent showing a new page as a pop-up which can be blocked */
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = caramelLink;
    link.click();
  }, []);

  const caramelBtnLink = (
    <Button
      className={classnames(
        'text-decoration-none text-transform-none text-blue-40 size-16 fw-normal caramel-btn-link v2 p-0',
        { 'd-block mb-1 ms-1_75': isTED6839Chal4Chal5Chal6, 'd-inline ms-md-0_5 mt-0': isTED6883Chal1Chal2Chal3 }
      )}
      onClick={handleCaramelBtnClick}
      color="link"
    >
      <i className="icon-arrow-right4 size-10" aria-hidden />
    </Button>
  );

  return (
    <>
      <div
        data-tracking-parent={CREATIVE_ID_ENTRY_PRIVATE_PARTY}
        className={classnames('private-party-entry-point-wrapper', {
          'mt-1 btn-view': isTED6839Chal1Chal2Chal3,
          'py-1 py-md-1_5 my-1 rounded-12 px-1 bg-white': isTED6839Chal4Chal5Chal6,
          ted6883: isTED6883Chal1Chal2Chal3,
          'rounded-12 bg-white d-md-inline-block': isTED6883Chal4Chal5Chal6,
        })}
      >
        {(isTED6839Chal1Chal2Chal3 || isTED6883Chal4Chal5Chal6) && (
          <Button
            className="text-decoration-none text-decoration-none-hover text-transform-none fw-normal d-flex justify-content-between align-items-center p-0 w-100 rounded-12 px-1 py-1 bg-white btn-wrapper"
            onClick={handleClick}
            color="link"
          >
            <div className="d-flex">
              <img src={getStaticImageUrl(image)} width={40} alt="" loading="lazy" />
              <div
                className={classnames(
                  'ms-0_75 me-1 benefits-container',
                  isTED6883Enabled ? `ted6883 ${ted6883Recipe}` : ted6839Recipe
                )}
              >
                <ul className="ps-1 ps-lg-0 benefits-list size-14 mb-0 d-lg-flex text-start v1">
                  {benefits.map((benefit, index) => (
                    <li key={`benefit_${index + 1}`} className="pe-md-2" style={{ minHeight: '20px' }} />
                  ))}
                </ul>
              </div>
            </div>

            <i className="icon-arrow-right4 text-primary" aria-hidden />
          </Button>
        )}
        {(isTED6839Chal4Chal5Chal6 || isTED6883Chal1Chal2Chal3) && (
          <>
            <div
              className={classnames(
                'd-inline benefits-container pos-r',
                isTED6883Enabled ? `ted6883 ${ted6883Recipe}` : ted6839Recipe
              )}
            />
            {(isTED6839Chal4 || isTED6883Chal1) && (
              <div
                className={classnames(
                  'd-inline benefits-container-second',
                  isTED6883Enabled ? `ted6883 ${ted6883Recipe}` : ted6839Recipe
                )}
              />
            )}
            <div className="d-flex flex-column flex-md-row mt-1_5">
              <img
                src={getStaticImageUrl(image)}
                className="mb-1_5 mb-md-0 me-md-2 mx-auto mx-md-0"
                width={isMobile ? 239 : 167}
                height={isMobile ? 159 : 135}
                alt=""
                loading="lazy"
              />
              <div>
                <ul className="list-unstyled mb-0 benefits-list v2">
                  {benefits.map((item, index) => (
                    <li
                      key={`benefit_${index + 1}`}
                      className="d-flex align-items-center pb-0_5"
                      style={{ minHeight: '30px' }}
                    >
                      <i aria-hidden className="icon-checkmark me-0_75 text-blue-50" />
                      <div>
                        <span className="benefit-item" />
                        <span className="benefit-item-second" />
                        {isTED6883Chal1Chal2Chal3 && index === 2 && caramelBtnLink}
                      </div>
                    </li>
                  ))}
                </ul>
                {isTED6839Chal4Chal5Chal6 && caramelBtnLink}
                <Button
                  className={classnames('btn-blue-50 text-transform-none size-16 text-white py-1 px-2 sell-car-cta', {
                    'mt-md-1': isTED6883Chal1Chal2Chal3,
                  })}
                  onClick={handleClick}
                  data-testid="sell-car-cta"
                />
              </div>
            </div>
          </>
        )}
      </div>
      {isTED6839Chal1Chal2Chal3 && (
        <Button
          className="text-decoration-none text-transform-none text-blue-40 size-14 mt-0_75 fw-normal d-block px-0 pt-0 pb-1 caramel-btn-link v1"
          onClick={handleCaramelBtnClick}
          color="link"
          data-testid="caramel-btn-link"
        >
          <i className="icon-arrow-right4 size-10" aria-hidden />
        </Button>
      )}
    </>
  );
}

PrivatePartySellCar.propTypes = {
  ted6839Recipe: PropTypes.string,
  ted6883Recipe: PropTypes.string,
  isMobile: PropTypes.bool,
};

PrivatePartySellCar.defaultProps = {
  ted6839Recipe: '',
  ted6883Recipe: '',
  isMobile: false,
};
